export const MESSAGE_LOG_GET = '[MESSAGE LOG] GET';
export const MESSAGE_LOG_SUCCESS = '[MESSAGE LOG] SUCCESS';
export const MESSAGE_LOG_FAIL = '[MESSAGE_LOG] FAIL';
